"use client";
import { motion, useMotionValue, useTransform } from "motion/react";
import { useEffect } from "react";

export const YolkLogo = ({ progress }: { progress: number }) => {
  const animationValue = useMotionValue(progress);
  const scale = useTransform(animationValue, [0, 50, 100], [0.25, 1.25, 1]);
  const rotate = useTransform(animationValue, [62.5, 100], [0, 290]);

  useEffect(() => {
    animationValue.set(progress);
  }, [progress, animationValue]);

  return (
    <motion.div
      initial={{ scale: 0.25 }}
      animate={{ scale: scale.get() }}
      transition={{
        type: "spring",
        stiffness: 120,
        damping: 200,
        duration: 0.3,
      }}
      className="w-[72px] h-[72px]"
    >
      <svg
        width={72}
        height={72}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.8604 10.0435C40.8663 9.28048 43.9937 8.76017 47.1172 9.33057C51.4109 10.1148 55.2899 13.2715 58.0723 17.4917C60.8639 21.7261 62.6279 27.1376 62.6279 32.6294C62.6279 40.2676 59.4465 47.1627 54.3418 52.0649V60.2485C54.3418 60.4116 54.3763 60.5866 54.4287 60.8774C54.4685 61.0979 54.5471 61.509 54.4707 61.9009C54.4269 62.1253 54.329 62.3725 54.1338 62.5913C53.9396 62.8088 53.697 62.9441 53.4502 63.0239C53.0068 63.1673 52.4637 63.1571 51.8594 63.0776C51.4173 63.0622 50.8551 62.916 50.2871 62.6987C49.6606 62.459 48.9405 62.1018 48.2178 61.6226C46.9864 60.806 45.6977 59.5988 44.8818 57.9604C42.0095 59.0041 38.9109 59.5757 35.6807 59.5757C20.7988 59.5755 8.73451 47.5113 8.73438 32.6294C8.73438 26.7141 11.0595 22.1436 14.7979 18.8052C18.5108 15.4895 23.5774 13.4207 29.0557 12.3716C30.4738 12.1 31.9141 11.713 33.3877 11.2935C34.8491 10.8774 36.3586 10.4246 37.8604 10.0435Z"
          fill="#020617"
          stroke="#020617"
          strokeWidth="1.84128"
        />
        <path
          d="M48.04 9.33057C44.9165 8.76016 41.7892 9.28046 38.7832 10.0435C37.2814 10.4246 35.772 10.8774 34.3105 11.2935C32.837 11.713 31.3967 12.1 29.9785 12.3716C24.5003 13.4207 19.4336 15.4895 15.7207 18.8052C11.9824 22.1436 9.65723 26.7141 9.65723 32.6294C9.65736 47.5114 21.7225 59.5757 36.6045 59.5757C39.8349 59.5756 42.9332 59.0042 45.8057 57.9604C46.6215 59.5986 47.9093 60.8061 49.1406 61.6226C49.8634 62.1018 50.5834 62.459 51.21 62.6987C51.8104 62.9285 52.405 63.0815 52.8574 63.0815C53.6623 63.0814 54.3155 62.7261 54.7344 62.1343C55.1246 61.5828 55.2646 60.8965 55.2646 60.2485V52.0649C60.3694 47.1627 63.5507 40.2676 63.5508 32.6294C63.5508 27.1375 61.7868 21.7261 58.9951 17.4917C56.2127 13.2714 52.3339 10.1147 48.04 9.33057Z"
          fill="#BEBFBF"
          stroke="#020617"
          strokeWidth="1.84128"
        />
        <path
          d="M30.1465 13.2666C35.9865 12.148 42.0197 9.15836 47.8691 10.2266C55.7996 11.6752 62.6239 22.0135 62.624 32.6191C62.624 40.1375 59.4357 46.9112 54.3379 51.6621V60.0078C50.1373 58.3059 47.9789 55.5123 46.9395 53.7305C34.9711 56.9527 29.4471 53.8837 27.1455 52.8096C14.758 47.0288 10.5098 36.6471 11.1143 28.0156C13.1867 19.6646 20.9636 15.0252 30.1465 13.2666Z"
          fill="#FDFFFF"
        />
        <g filter="url(#filter0_f_10747_6975)">
          <path
            d="M24.667 33.7358C24.667 41.8703 31.2611 48.4644 39.3955 48.4644C47.5299 48.4644 54.124 41.8703 54.124 33.7358C54.124 25.6014 47.5299 19.0073 39.3955 19.0073C31.2611 19.0073 24.667 25.6014 24.667 33.7358Z"
            fill="#D56311"
          />
        </g>
        <motion.g
          initial={false}
          animate={{ rotate: rotate.get() }}
          transition={{
            type: "spring",
            stiffness: 120,
            damping: 200,
            duration: 0.3,
          }}
          filter="url(#filter1_ii_10747_6975)"
        >
          <path
            d="M25.3066 32.0288C25.3066 40.1632 31.9007 46.7573 40.0351 46.7573C48.1696 46.7573 54.7637 40.1632 54.7637 32.0288C54.7637 23.8944 48.1696 17.3003 40.0351 17.3003C31.9007 17.3003 25.3066 23.8944 25.3066 32.0288Z"
            fill="#FDCC0B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.7126 23.4798C41.2609 24.668 41.8579 25.9973 43.0461 26.449C43.6855 26.6921 44.2228 27.0532 44.6519 27.5275C45.137 28.0637 45.4671 28.7267 45.6301 29.5071C45.8899 30.7514 47.1093 31.5494 48.3536 31.2896C49.5979 31.0297 50.3959 29.8104 50.1361 28.5661C49.8208 27.0561 49.1452 25.6328 48.0655 24.4393C47.1151 23.3888 45.9539 22.6298 44.6818 22.1462C43.4936 21.6946 42.1642 22.2916 41.7126 23.4798Z"
            fill="white"
            fillOpacity="0.7"
          />
        </motion.g>
        <defs>
          <filter
            id="filter0_f_10747_6975"
            x="22.9593"
            y="17.2997"
            width="32.8723"
            height="32.8723"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.853828"
              result="effect1_foregroundBlur_10747_6975"
            />
          </filter>
          <filter
            id="filter1_ii_10747_6975"
            x="22.7452"
            y="13.885"
            width="32.0185"
            height="32.8723"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2.56148" dy="-3.41531" />
            <feGaussianBlur stdDeviation="2.77494" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.921569 0 0 0 0 0.568627 0 0 0 0 0.0196078 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_10747_6975"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-0.426914" dy="-1.4942" />
            <feGaussianBlur stdDeviation="1.17401" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.848926 0 0 0 0 0.45842 0 0 0 0 0 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_innerShadow_10747_6975"
              result="effect2_innerShadow_10747_6975"
            />
          </filter>
        </defs>
      </svg>
    </motion.div>
  );
};
